import typeToReducer from 'type-to-reducer';
import update from 'immutability-helper';
import { Reducer } from '@reduxjs/toolkit';
import {
  employeesInitialState,
  EmployeesInitialStateType,
} from '../store/initialState';
import { PublistaAction } from '../infrastructure/commonTypes';
import { parseAxiosError } from '../utils/axiosResponseHelper';

export const employeesReducer: Reducer<
  EmployeesInitialStateType,
  PublistaAction
> = typeToReducer<EmployeesInitialStateType, PublistaAction>(
  {
    CITY_USERS_GET: {
      PENDING: (state: EmployeesInitialStateType) =>
        update(state, {
          fetching: { $set: true },
        }),
      REJECTED: (state: EmployeesInitialStateType, action: any) => {
        const payload = action?.payload;

        return update(state, {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: parseAxiosError(payload) },
        });
      },
      FULFILLED: (state: EmployeesInitialStateType, action: any) => {
        const payload = action?.payload;

        return update(state, {
          fetching: { $set: false },
          fetched: { $set: true },
          data: {
            $set: payload.data,
          },
          error: { $set: null },
        });
      },
    },
  },
  employeesInitialState
);
